export const BOOKABLE_BUSY_FETCH_REQUESTED = 'BOOKABLE_BUSY_FETCH_REQUESTED';
export const BOOKABLE_BUSY_FETCH_SUCCEEDED = 'BOOKABLE_BUSY_FETCH_SUCCEEDED';
export const BOOKABLE_BUSY_FETCH_FAILED = 'BOOKABLE_BUSY_FETCH_FAILED';
